import { Label } from 'components/ui/label';
import AdminOnly from 'components/AdminOnly';
import { Checkbox } from 'components/ui/checkbox';
import { useAppSelector } from 'hooks';
import { Card, CardContent, CardHeader } from 'components/ui/card';
import firebase from 'firebase/compat/app';
import { toast } from 'sonner';

const db = firebase.firestore();

export default function MachineTaskEnabled({ orgId }: { orgId: string }) {
  const machineAdhocEnabled = useAppSelector(
    (state) => state.orgs.orgMap[orgId]?.machineAdhocEnabled
  );

  const handleChange = async (checked: boolean) => {
    try {
      await db.collection('orgs').doc(orgId).update({ machineAdhocEnabled: checked });
      toast.success(`Adhoc Maskineopgaver ${checked ? 'aktiveret' : 'deaktiveret'}`);
    } catch (error) {
      console.error(error);
      toast.error(`Adhoc Maskineopgaver kunne ikke ${checked ? 'aktiveres' : 'deaktiveres'}`);
    }
  };

  return (
    <AdminOnly>
      <Card>
        <CardHeader>
          <div className="flex items-center space-x-2">Adhoc Maskineopgaver</div>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="machineAdhocEnabled"
              checked={machineAdhocEnabled}
              onCheckedChange={(checked) => handleChange(checked as boolean)}
            />
            <Label htmlFor="machineAdhocEnabled">Aktiver Adhoc Maskineopgaver</Label>
          </div>
        </CardContent>
      </Card>
    </AdminOnly>
  );
}
